import { MenuProvider } from '../../../../../services/exports/Constants';

export default {
  form: {
    provider: {
      label: 'Furnizor meniu',
      options: {
        [null]: 'Selectați furnizorul de meniu',
        [MenuProvider.Lieferando]: 'Lieferando',
        [MenuProvider.Wolt]: 'Wolt',
        [MenuProvider.Deliveroo]: 'Deliveroo',
        [MenuProvider.UberEats]: 'Uber Eats',
        [MenuProvider.GloriaFood]: 'GloriaFood',
        [MenuProvider.Foodamigos]: 'Alt restaurant FoodAmigos',
        [MenuProvider.DoorDash]: 'DoorDash',
        [MenuProvider.Tabless]: 'Tabless (POS)',
        [MenuProvider.Thuisbezorgd]: 'Thuisbezorgd',
        [MenuProvider.TakeawayCom]: 'Takeaway.com',
        [MenuProvider.PysznePl]: 'Pyszne.pl',
        [MenuProvider.BistroSk]: 'Bistro.sk',
        [MenuProvider.JustEat]: 'Just Eat',
      },
    },
    provider_id: {
      [MenuProvider.Lieferando]: {
        label: 'URL Lieferando',
        placeholder: 'URL-ul restaurantului în Lieferando',
      },
      [MenuProvider.Wolt]: {
        label: 'URL Wolt',
        placeholder: 'URL-ul restaurantului în Wolt',
      },
      [MenuProvider.Deliveroo]: {
        label: 'Linkul restaurantului pe Deliveroo',
        placeholder: 'https://deliveroo…/menu/city/area/restaurant',
        help: 'Deschideți restaurantul pe Deliveroo și copiați linkul din bara de adrese.',
        error:
          'Introduceți linkul către pagina meniului unui restaurant pe Deliveroo. Arată așa: https://deliveroo.co.uk/menu/city/area/restaurant-name.',
      },
      [MenuProvider.UberEats]: {
        label: 'URL Uber Eats',
        placeholder: 'URL-ul restaurantului în Uber Eats',
      },
      [MenuProvider.GloriaFood]: {
        label: 'Link GloriaFood',
        placeholder: 'https://www.foodbooking.com/ordering/restaurant/menu?restaurant_uid=…',
        help: {
          ordering_page: {
            title: 'Dacă folosiți pagina de comandă GloriaFood:',
            description: 'Introduceți URL-ul de comandă foodbooking.com.',
            example: 'https://www.foodbooking.com/ordering/restaurant/menu?restaurant_uid=…',
          },
          embedded_widget: {
            title: 'Dacă GloriaFood este integrat în propriul dvs. site:',
            description: 'Introduceți URL-ul paginii de pe site-ul dvs. pe care apare widget-ul de comandă.',
            example: 'https://yourrestaurant.com/order',
          },
        },
        error: 'Introduceți un link valid care începe cu https://.',
        back_office_error:
          'Acesta este un link din back-office-ul GloriaFood, nu pagina de pe care comandă clienții dvs. Deschideți pagina de comandă a restaurantului dvs. și inserați acel link în schimb.',
        wrong_platform_error:
          'Acesta nu pare a fi un link GloriaFood. Dacă folosiți pagina de comandă găzduită de GloriaFood, introduceți URL-ul de comandă foodbooking.com. Dacă GloriaFood este integrat în propriul dvs. site, introduceți URL-ul paginii pe care apare widget-ul de comandă.',
      },
      [MenuProvider.Thuisbezorgd]: {
        label: 'URL Thuisbezorgd',
        placeholder: 'URL-ul restaurantului pe Thuisbezorgd',
      },
      [MenuProvider.TakeawayCom]: {
        label: 'URL Takeaway.com',
        placeholder: 'URL-ul restaurantului pe Takeaway.com',
      },
      [MenuProvider.PysznePl]: {
        label: 'URL Pyszne.pl',
        placeholder: 'URL-ul restaurantului pe Pyszne.pl',
      },
      [MenuProvider.BistroSk]: {
        label: 'URL Bistro.sk',
        placeholder: 'URL-ul restaurantului pe Bistro.sk',
      },
      [MenuProvider.JustEat]: {
        label: 'URL Just Eat',
        placeholder: 'URL-ul restaurantului pe Just Eat',
      },
      [MenuProvider.DoorDash]: {
        label: 'Linkul restaurantului pe DoorDash',
        placeholder: 'https://www.doordash.com/store/…',
        help: 'Deschideți restaurantul pe doordash.com și copiați linkul din bara de adrese.',
        error: 'Introduceți linkul către o pagină de restaurant DoorDash. Începe cu https://www.doordash.com/store/.',
        store_number_error:
          'Acest link conține doar numărul magazinului. Deschideți restaurantul pe doordash.com și copiați linkul cu numele său, de exemplu https://www.doordash.com/store/restaurant-name-123456/.',
      },
      [MenuProvider.Foodamigos]: {
        label: 'Restaurant din care se copiază meniul',
        placeholder: 'Selectați restaurantul din care se copiază meniul',
      },
    },
  },
};
